module.exports = __webpack_public_path__ + "img/icon_rim.f3db6733.png";